/** The words of a cue without WebVTT's markup (voice, italics, classes), each line trimmed. */
export function lyricText(raw) {
    return raw
        .replace(/<[^>]*>/g, '')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&nbsp;/g, ' ')
        .split('\n')
        .map((line) => line.replace(/\s+/g, ' ').trim())
        .filter(Boolean)
        .join('\n');
}
/**
 * A track's cues as lyrics: in time order, without the empty ones, and without a cue repeated at the same time,
 * which a stream's subtitle segments carry where they overlap.
 */
export function cuesToLyrics(cues) {
    if (!cues)
        return [];
    const lines = [];
    for (const cue of Array.from(cues)) {
        const text = lyricText(cue.text ?? '');
        if (text)
            lines.push({ start: cue.startTime, end: cue.endTime, text });
    }
    lines.sort((a, b) => a.start - b.start);
    return lines.filter((line, i) => {
        const before = lines[i - 1];
        return !before || line.start !== before.start || line.text !== before.text;
    });
}
/**
 * The line being sung at `time`: the last one that has started. It stays lit through the pause after it until the
 * next begins, so the eye does not lose its place; -1 before the first.
 */
export function activeLyric(lines, time) {
    let found = -1;
    for (const [i, line] of lines.entries()) {
        if (line.start > time)
            break;
        found = i;
    }
    return found;
}
//# sourceMappingURL=lyrics.js.map